// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1Xv3A","col":"Table_col__3uKCm","fulfillmentStatus":"Table_fulfillmentStatus__L7kyW","emailCol":"Table_emailCol__1gmTv"};